(function () {
    "use strict";

    var NbdCalendarParameterControl = Solovis.defineClass(
        "Solovis.Reports.Parameters.NbdCalendarParameterControl",
        Solovis.UI.BaseControl,
        function (options) {
            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
            this._currentCalendar = this.initialParameterValue;
            this._selectionDialog = null;
            this._reportCodeForNbdCalendarInfo = "A0657A98-1183-40F1-9F17-9914F8EA12EE";
        });

    NbdCalendarParameterControl.serializeParameterValue = function (value) {
        if (value) {
            if (value.id) {
                return { id: value.id };
            }
        }

        return null;
    };

    NbdCalendarParameterControl.prototype.doInit = function () {
    };

    NbdCalendarParameterControl.preload = function (newValue, callback) {
        if (newValue && (newValue.id || newValue.label)) {
            var loadOptions: any = { nbdCalendar: {} };
            if (newValue.id)
                loadOptions.nbdCalendar.id = newValue.id;
            if (newValue.label)
                loadOptions.nbdCalendar.label = newValue.label;

            Solovis.Reports.ReportDataLoader.loadDataSetAsync("/Solovis/Metadata/ParameterLoad",
                loadOptions,
                function (response, success) {
                    if (success) {
                        var dataSet = response.result.dataSet;
                        var nbdCalendarData = dataSet.nbdCalendar ? dataSet.nbdCalendar : null;
                        callback(nbdCalendarData, true);
                    }
                    else {
                        callback(null, false);
                    }
                });
        }
        else {
            callback(null, true);
        }
    };

    NbdCalendarParameterControl.shouldPreload = function (value) {
        if (!value || (value.id && value.label)) {
            // Already loaded.
            return false;
        }

        return true;
    };

    NbdCalendarParameterControl.prototype.doRender = function () {
        var self = this;

        this._selectedCalendarLabel = $("<a>").appendTo(this.container)
            .click(function (e) {
                if (self._currentCalendar && self._currentCalendar.id) {
                    Solovis.UI.PopupLinkPanel.showLinks({
                        offsetElement: this,
                        offsetRight: true,
                        links: [
                            {
                                label: "Non-Business Day Calendar Info",
                                href: Solovis.Reports.ReportLinker.getReportLink({
                                    reportCode: self._reportCodeForNbdCalendarInfo,
                                    parameters: { nbdCalendar: self._currentCalendar },
                                    autoRun: true,
                                    collapseConfigSection: true
                                })
                            }
                        ]
                    });
                }
            });

        this._selectCalendarLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);

        this._selectCalendarLink.click(function () {
            self._toggleSelectorDialog(function (property) {
                self._setCurrentCalendarData(property);
                self.notifyParameterValueChanged();
            });
        });

        // Set initial parameter value text.
        if (this._currentCalendar) {
            this._setCurrentCalendarData(this._currentCalendar);
        }
    };

    NbdCalendarParameterControl.prototype._toggleSelectorDialog = function (selectionCallback) {
        var self = this;

        if (this._selectionDialog) {
            // We already have the selection dialog open, so close it.
            this._selectionDialog.close();
            this._selectionDialog = null;
            return;
        }

        Solovis.Reports.ReportDataLoader.loadDataSetAsync("/Solovis/Liquidity/NbdCalendarList",
            { includeDays: false, nbdCalendarIdsToLoad: null },
            function (response, success) {
                if (success) {
                    self._nbdCalendars = response.result.dataSet.calendars;

                    self._showDialog(selectionCallback);
                }
            },
            { invokeMethod: "invokeAndWait" });
    };

    NbdCalendarParameterControl.prototype._showDialog = function (selectionCallback) {
        var self = this;

        var selectorControlHostDiv = $("<div>");
        var selectorControlHost = new Solovis.UI.ControlHost({ container: selectorControlHostDiv });

        var selectorControl = new Solovis.UI.StringFilterListControl({
            controlHost: selectorControlHostDiv,
            listItems: this._nbdCalendars,
            useDefaultSort: true,
            selectedItem: this._currentCalendar ? this._currentCalendar : null
        });

        $(selectorControl)
            .on("selectionChanged", function (e, data) {
                var selectedItem = data.item;
                selectionCallback(selectedItem);
                self._selectionDialog.close();
            })
            .on("escapeKey", function () {
                self._selectionDialog.close();
            });

        selectorControlHost.setCurrentControl(selectorControl);

        //Determine dialog position.
        var linkOffset = $(this._selectedCalendarLabel).offset();
        var linkHeight = $(this._selectCalendarLink).outerHeight();
        var dialogPosition = {
            left: linkOffset.left,
            top: linkOffset.top + linkHeight + 5
        };

        var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });

        var desiredWidth = Math.min($(window).width() * .8, 250);
        var desiredHeight = Math.min($(window).height() * .8, 300);

        var minWidth = 100;
        var minHeight = 100;

        this._selectionDialog = new Solovis.UI.Dialog({
            container: selectorControlHostDiv,
            ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

            title: false,
            autoOpen: true,
            destroyOnClose: true,
            actions: ["Close"],
            noAnimation: true,
            position: adjustedPosition,
            width: desiredWidth,
            minWidth: minWidth,
            minHeight: minHeight,
            height: desiredHeight,

            buttons: [
                {
                    label: "Clear",
                    click: function () {
                        selectionCallback(null);
                        self._selectionDialog.close();
                    }
                },
                {
                    label: "Cancel",
                    click: function () {
                        self._selectionDialog.close();
                    }
                }
            ],

            resize: function () {
                var overallHeight = this.getAvailableContentHeight();
                selectorControl.setAvailableHeight(overallHeight);
            },

            activate: function () {
                var overallHeight = this.getAvailableContentHeight();
                selectorControl.setAvailableHeight(overallHeight);
                selectorControl.focusFilter();
                selectorControl.scrollToSelectedItem();
            },

            deactivate: function () {
                self._selectionDialog = null;
            }
        });
    };

    NbdCalendarParameterControl.prototype.notifyParameterValueChanged = function () {
        $(this).trigger("parameterValueChanged");
    };

    NbdCalendarParameterControl.prototype._setCurrentCalendarData = function (calendarData) {
        var self = this;

        this._currentCalendar = calendarData;
        if (this._currentCalendar) {

            this._selectedCalendarLabel.text(this._currentCalendar.label + " ");
        }
        else {
            this._selectedCalendarLabel.text("");
        }
    };

    NbdCalendarParameterControl.prototype.setParameterValue = function (newValue, more) {
        Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
            this, NbdCalendarParameterControl, this._setCurrentCalendarData, newValue, more);
    };

    NbdCalendarParameterControl.prototype.getParameterValue = function () {
        if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
            return this.initialParameterValue ? this.initialParameterValue : null;
        }
        else if (this._currentCalendar) {
            return Solovis.deepCopy(this._currentCalendar);
        }
        else {
            return null;
        }
    };
})();